<script lang="ts">
    import Input from "../Form/Input.svelte";
    import {loginSchema} from "../../validationsForm/loginValidation.ts";
    import {ApiCall} from "../../services/ApiCall.ts";
    import {push, link} from "svelte-spa-router";
    import {cookieName, authenticationStatus} from "../../store/stores.ts";

    type Credential = {email: string, password: string};
    let credential:Credential = {email: '', password: ''};

    let submitted = false;

    let errors = {};
    async function login() {

        try {
            await loginSchema.validate(credential, {abortEarly: false});
            errors = {};

            await makeApiCall();
        }
        catch (err) {
            errors = err.inner.reduce((acc, err) => {
                return ( { ...acc, [err.path]: err.message });
            }, {});
        }
    }

    let errorForm = false;
    async function makeApiCall() {

        const apiCall = new ApiCall();

        try{
            const content = await apiCall.postRequest('applicateur/login', credential);

            if (content.success === false) {
                errorForm = true;
            }
            else{
                let authStatus = {authenticated: content.success}
                authenticationStatus.set(authStatus)

                let cookieName_value:string;
                cookieName.subscribe(value => {
                    cookieName_value = value;
                });

                document.cookie = cookieName_value + '=' +  content.data.token + '; path=/; max-age=604800; secure';

                push('/commande/ajout')
            }
        }
        catch (e) {
            push('/erreur500')
        }
    }

</script>

<h2 class="title is-2 has-text-centered mb-6">Bienvenue sur Chrono Chape</h2>

<div class="is-flex is-justify-content-center-mobile mx-3 columns">
    <div class="box column is-three-fifths-desktop is-offset-one-fifth-desktop p-6">
        <h3 class="title is-3 has-text-centered">Veuillez vous connecter pour passer une commande</h3>
        <form id="login-form" class:submitted on:submit|preventDefault={login}>
            <Input bind:value={credential.email} label="Email" name="email" placeholder="Veuillez saisir votre adresse email" error={errors.email}  autocomplete="email" type="email" autofocus required/>
            <Input bind:value={credential.password} label="Mot de passe" name="password" placeholder="Veuillez saisir votre mot de passe" error={errors.password}  autocomplete="current-password" type="password" required/>
            {#if errorForm}
                <p class="help is-danger">Vos identifiants sont invalides, veuillez réessayer.</p>
            {/if}
            <div class="field pt-3">
                <p class="control">
                    <button class="button is-success" type="submit" on:click={() => submitted = true}>Se connecter</button>
                </p>
            </div>
        </form>
    </div>
</div>
<div class="is-justify-content-center is-flex">
    <a href="/compte/mot-de-passe" use:link class="request-link">Mot de passe oublié ?</a>
</div>
<div class="divider my-6">OU</div>
<div class="is-justify-content-center is-flex">
    <a href="/compte/demande-creation" use:link class="button is-info link">Demande de création de compte</a>
</div>


